import { render } from "./MarketplaceBanner.vue?vue&type=template&id=4b25f6b3&scoped=true"
import script from "./MarketplaceBanner.vue?vue&type=script&lang=js"
export * from "./MarketplaceBanner.vue?vue&type=script&lang=js"

import "./MarketplaceBanner.vue?vue&type=style&index=0&id=4b25f6b3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b25f6b3"]])

export default __exports__